import { camelCase, lowerCase } from 'lodash-es';
import storage from '../utilities/storage';
import { getTranslation } from '../utilities/translator';

export const useUITranslate = () => {
  const lang = storage.get('lang', 'id');

  /**
   * @param key Key of the translation **without convention**, will be formatted to our convention internally.
   * @example
   * ```ts
   * translate('No Transaction Found') // will find translation with key `noTransactionFound`
   * ```
   */
  const translate = (key: string) => {
    const formattedKey = camelCase(lowerCase(key));
    const translation = getTranslation(lang, formattedKey);
    if (!translation) return key;
    return translation;
  };

  return { translate, lang };
};
